export const mediaFileListSelector = (state: any) =>
  state.MediaFileReducer.mediaFileList;
